import React, { useMemo } from 'react';
import PreSendDialog from '../../presend/components/PreSendDialog';

/**
 * Invite All to the buyer portal, on the shared pre-send engine.
 *
 * On 27 Oct 2026 one click queued ~33,000 portal invites and hundreds greeted
 * people as "Hi 69124". CG (Monday 13391839919): agents see exactly who gets
 * an invite before it is sent, large sends need a second person's approval
 * after a test, and invites go out a few a minute with pause and cancel.
 */
const InviteAllDialog = ({ filters, onClose }) => {
  const params = useMemo(() => ({ filters }), [filters]);
  return (
    <PreSendDialog
      kind="portal_invite" params={params} title="Invite to Buyer Portal" noun="invite" onClose={onClose}
    />
  );
};

// Kept for the legacy batch page, which still shows batches until they finish.
export { formatCount, formatMinutes } from '../../presend/format';

export default InviteAllDialog;
